/* eslint-disable sonarjs/no-duplicate-string */
import type { PartsStyleInterpolation, PartsStyleObject } from '@chakra-ui/react';
import { tabsAnatomy as parts } from '@chakra-ui/anatomy';

const variantMbe: PartsStyleObject<typeof parts> = {
  tab: {
    fontWeight: 'medium',
    _hover: {
      color: 'brand.red.light',
    },
    _selected: {
      color: 'brand.red.light',
      bg: 'white',
      border: '2px',
      borderColor: 'brand.red.light',
      borderRadius: '25px',
    },
  },
};

const variants: Record<string, PartsStyleInterpolation<typeof parts>> = {
  mbe: variantMbe,
};

export default {
  parts: parts.keys,
  variants,
};
